import { CSSProperties } from 'react';
import { IFeature } from 'mod/feature/interface';
import { IProduct } from 'mod/product/interface';
import { get750RemValue } from 'base/utils/dom-size';
import { IProductContext } from 'mod/product-list/useProductContext';
import { LIST_ITEM_TYPE_PRODUCT } from 'mod/product-list/constant';
import { ITrackerData } from '@base/lib/Tracker';

// 获取打点module code
export function getModuleCode(data: { moduleId?: string; }): string {
    return data.moduleId ? `${process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 'H5' : 'WEB'} ${data.moduleId}` : '';
}

export function getModuleElementId(data: IFeature): string {
    return data.moduleId ? data.moduleId.trim().replaceAll(' ', '-').toLowerCase() : ''
}

export function getProductTrackData(product: IProduct, config: IProductContext['track']): ITrackerData {
    const moduleCode = config?.module;

    if (!moduleCode) {
        return {
            ...product,
            listTrackCode: config?.listTrackCode,
            position: config?.position || 1,
        };
    }

    let target = product.track.variant;
    if (config.targetPrefix) {
        target = `${config.targetPrefix}:${target}`;
    }

    return {
        ...product,
        track: {
            ...product.track,
            list: config?.listTrackCode || moduleCode
        },
        targetType: config.itemType === LIST_ITEM_TYPE_PRODUCT ? 'product' : 'variant', // product
        target,
        relTarget: target,
        module: moduleCode,
        position: config.position || 1,
    }
}

export function getWrapSpaceStyle(space: IFeature['space']): CSSProperties {
    const style: CSSProperties = {};
    const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';
    if (space) {
        Object.entries(space).forEach(([key, value]) => {
            if (value > 0) {
                style[key] = isPhone ? get750RemValue(value) : `${value}px`;
            }
        });
    }
    return style;
}

export function getWrapBgStyle(background): CSSProperties {
    const style: CSSProperties = {};
    const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

    if (background?.image) {
        style.backgroundImage = `url('${background.image}')`;
        style.backgroundPosition = 'top center';
        if (isPhone) {
            style.backgroundSize = '100% auto';
        }
    }
    if (background?.color) {
        style.backgroundColor = background.color;
    }
    return style;
}

export function getWrapStyle({ background, space }: IFeature): CSSProperties {

    return {
        ...getWrapBgStyle(background),
        ...getWrapSpaceStyle(space)
    };
}